<template>
  <div class="max-w-3xl mx-auto text-center">
    <h1 class="text-2xl font-bold">
      Thanks {{ $store.state.onboarding.profile.firstName }}! Now let's set up your team.
    </h1>
    <p class="text-lg mb-4">
      We'll use this information for your team's profile and it can be always be changed later.
    </p>
    <FormKit v-model="formData" type="form" class="mt-8" :actions="false" @submit="$emit('next')">
      <FormKit type="text" name="name" label="Team Name" validation="required" placeholder="Enter team name" />
      <FormKit
        type="tel"
        name="primaryPhoneNumber"
        label="Primary Phone Number"
        validation="required"
        placeholder="Enter primary phone number"
      />
      <FormKit
        type="address-input"
        name="primaryAddress"
        label="Primary Address"
        validation="required"
        placeholder="Enter primary address"
      />
      <FormKit
        type="select"
        name="companyType"
        label="Company Type"
        :options="companyTypes"
        placeholder="Select company type"
        validation="required"
      />
      <FormKit type="submit" label="Continue" class="btn btn-primary" />
    </FormKit>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AddressInput from '../../../../components/shared/AddressInput.vue';
export default {
  components: {
    AddressInput,
  },
  computed: {
    companyTypes() {
      return ['Real Estate', 'Mortgage'];
    },
    formData: {
      set(newData) {
        this.$store.commit('onboarding/setTeam', newData);
      },
      get() {
        return this.team;
      },
    },
    ...mapState({
      team: state => state.onboarding.team,
    }),
  },
};
</script>
